import React from 'react'
import { Link } from 'react-router-dom'

const CircleHome = props => {
    const circleStyle ={
        borderRadius:"250px",
        display:"flex",
        justifyContent:"center",
        alignItems:"center",
        flexDirection:"column",
        maxWidth:"180px",
        textAlign:"center",
        Gap: "60px"
    }
    return (
        <div className="text-center" style={circleStyle}>
            <Link className="circle-best" to={props.link ? "herramientas"+props.link : ""}>
            <img style={{width:"100px"}} src={props.img} alt=""/>
            <p style={{fontSize:"16px", textDecoration:"none", marginTop:"16px", color: "#8f8b0c"}} dangerouslySetInnerHTML={{__html:props.text}}></p>
            
            </Link>
        </div>
    )
}

export default CircleHome